import { useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import { useApiMutation } from '../useApiMutation';
import { taskKeys } from '@/lib/queryKeys';
import { taskEndpoints } from '@/lib/api/endpoints';
import { apiPost, operationsClient } from '@/lib/api';
import type { Task, CreateTaskDto } from '@/types/task';

export function useCreateTask(options?: { showSuccessToast?: boolean; showErrorToast?: boolean }) {
  const queryClient = useQueryClient();

  return useApiMutation<Task, CreateTaskDto>({
    showErrorToast: options?.showErrorToast,
    mutationFn: (dto) => {
      const { contactId, ...body } = dto;
      if (!contactId) throw new Error('contactId is required to create a task');
      return apiPost<Task>(operationsClient, taskEndpoints.create(contactId), body);
    },
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: taskKeys.lists() });
      void queryClient.invalidateQueries({ queryKey: taskKeys.countsAll() });
      if (options?.showSuccessToast !== false) {
        toast.success('Task created');
      }
    },
  });
}
